export const resourceNavigation = {
    resources: {
        name: 'Resources',
        href: '/members/resources'
    },
    library: {
        name: 'Experts Library',
        href: '/members/resources/library'
    },
    favorites: {
        name: 'Favorites',
        href: '/members/resources/favorites'
    },
    courses: {
        name: 'Courses',
        href: '/members/resources/courses'
    }
};
